import {
    Card,
    CardContent,
    CardHeader,
    Chip,
    CircularProgress,
    IconButton,
    Paper,
    Switch,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@mui/material";
import { Refresh } from "@mui/icons-material";
import { Receiver } from "../../interface/returnOps";

interface ReceiversTableProps {
    receivers: Receiver[];
    loading: boolean;
    onRefresh: () => void;
    onToggle: (receiverId: string, enabled: boolean) => void;
}

const ReceiversTable = ({ receivers, loading, onRefresh, onToggle }: ReceiversTableProps) => (
    <Card>
        <CardHeader
            title="Receivers"
            action={(
                <IconButton onClick={onRefresh} disabled={loading}>
                    <Refresh />
                </IconButton>
            )}
        />
        <CardContent>
            {loading ? (
                <CircularProgress />
            ) : (
                <TableContainer component={Paper} variant="outlined">
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>ID</TableCell>
                                <TableCell>Topic Name</TableCell>
                                <TableCell>Subscription Name</TableCell>
                                <TableCell>Connected</TableCell>
                                <TableCell>Enabled</TableCell>
                                <TableCell>Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {receivers.map((receiver) => (
                                <TableRow key={receiver.id}>
                                    <TableCell>{receiver.id}</TableCell>
                                    <TableCell>{receiver.topicName}</TableCell>
                                    <TableCell>{receiver.subscriptionName}</TableCell>
                                    <TableCell>
                                        <Chip
                                            label={receiver.connected ? "Connected" : "Disconnected"}
                                            color={receiver.connected ? "success" : "default"}
                                            size="small"
                                        />
                                    </TableCell>
                                    <TableCell>
                                        <Chip
                                            label={receiver.enabled ? "Enabled" : "Disabled"}
                                            color={receiver.enabled ? "success" : "default"}
                                            size="small"
                                        />
                                    </TableCell>
                                    <TableCell>
                                        <Switch
                                            checked={receiver.enabled}
                                            onChange={() => onToggle(receiver.id, receiver.enabled)}
                                            color="primary"
                                        />
                                    </TableCell>
                                </TableRow>
                            ))}
                            {receivers.length === 0 && (
                                <TableRow>
                                    <TableCell colSpan={6} align="center">
                                        No receivers found
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}
        </CardContent>
    </Card>
);

export default ReceiversTable;
